// extracted by mini-css-extract-plugin
export default {"wrapper":"preview_wrapper__-4eed","header":"preview_header__6ni+8","crud":"preview_crud__06IYd","chatBody":"preview_chatBody__0OJw7","footer":"preview_footer__NLCa6"};